const middlewareConstants = {
	//new update for headers and credentials only, request type will define in middelwareService
	requestWithCredentials: {
		credentials: 'include',
		headers: {
			"use-pkey": false
		}
	},

	requestWithCredentialsJson: {
		credentials: 'include',
		headers: {
				'Content-Type': 'application/json; charset=UTF-8',
				'Accept': 'application/json; charset=UTF-8',
				"use-pkey" : false
		}
	},

	requestWithCredentialsJsonBSE: {
		credentials: 'include',
		headers: {
				'Content-Type': 'application/json; charset=UTF-8',
				"use-pkey" : false
		}
	},

	requestWithoutCredentialsJson: {
		headers: {
			'Content-Type': 'application/json; charset=UTF-8',
			"use-pkey" : false
		}
	},
	
	requestWithCredentialsXwww: {
		credentials: 'include',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
			"use-pkey" : false
		}
	},

	requestWithoutCredentialsXwww: {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
			"use-pkey" : false
		}
	}

}
export default middlewareConstants;
